import React, { JSX } from "react";
import { HeaderComponent } from "../header/Header.component";
import { TabContainer } from "../tab-container/TabContainer.component";
import { tabs } from "../../data/tabs";
import { useMenu } from "../menu/useMenu";
import Me from "@assets/images/me.png";

export const AppComponent = (): JSX.Element => {
  const { selectedTab } = useMenu();

  return (
    <main>
      <HeaderComponent logo={Me} title="Daniel de Witte" />
      <TabContainer selectedTab={selectedTab} tabs={tabs} />
    </main>
  );
};
